/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIImageReference
 */
export interface AIImageReference {
    /**
     * 
     * @type {string}
     * @memberof AIImageReference
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AIImageReference
     */
    readonly asset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIImageReference
     */
    readonly proxy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIImageReference
     */
    readonly frame?: number;
    /**
     * 
     * @type {string}
     * @memberof AIImageReference
     */
    readonly filename?: string;
    /**
     * 
     * @type {string}
     * @memberof AIImageReference
     */
    readonly dataset?: string;
    /**
     * 
     * @type {number}
     * @memberof AIImageReference
     */
    readonly width?: number;
    /**
     * 
     * @type {number}
     * @memberof AIImageReference
     */
    readonly height?: number;
}

export function AIImageReferenceFromJSON(json: any): AIImageReference {
    return AIImageReferenceFromJSONTyped(json, false);
}

export function AIImageReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIImageReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'proxy': !exists(json, 'proxy') ? undefined : json['proxy'],
        'frame': !exists(json, 'frame') ? undefined : json['frame'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'dataset': !exists(json, 'dataset') ? undefined : json['dataset'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
    };
}

export function AIImageReferenceToJSON(value?: AIImageReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


